import Cookies from "js-cookie";

const PREFIX = '_mp_';
const VERSION_KEY = '_mp_version';
const VERSION_COOKIE = '_sv';
const DEFAULT_TTL_MS = 0.4 * 24 * 60 * 60 * 1000; // ~10h, same as cookies

function getLocalVersion() {
    return localStorage.getItem(VERSION_KEY);
}

function getCookieVersion() {
    return Cookies.get(VERSION_COOKIE) || null;
}

function syncVersion() {
    const cookieVersion = getCookieVersion();
    const localVersion = getLocalVersion();

    if (!cookieVersion) {
        // Cookie was removed (logout on another subdomain) — clear local data
        if (localVersion) {
            clearAll();
        }
        return;
    }

    if (localVersion && localVersion !== cookieVersion) {
        // Version mismatch (org change or re-login on another subdomain) — clear stale data
        clearAll();
    }
}

function stampVersion() {
    const version = getCookieVersion() || Date.now().toString(36) + Math.random().toString(36).slice(2, 6);
    localStorage.setItem(VERSION_KEY, version);
    Cookies.set(VERSION_COOKIE, version, {domain: process.env.REACT_APP_HOST, expires: 0.4, secure: true});
}

function clearAll() {
    Object.keys(localStorage)
        .filter(k => k.startsWith(PREFIX))
        .forEach(k => localStorage.removeItem(k));
}

// Check version on module load (every page load / subdomain navigation)
syncVersion();

export const sessionStore = {
    set: (key, value, ttlMs = DEFAULT_TTL_MS) => {
        const item = { value, expiresAt: Date.now() + ttlMs };
        localStorage.setItem(PREFIX + key, JSON.stringify(item));
        stampVersion();
    },
    get: (key) => {
        const raw = localStorage.getItem(PREFIX + key);
        if (!raw) return null;
        try {
            const item = JSON.parse(raw);
            if (Date.now() > item.expiresAt) {
                localStorage.removeItem(PREFIX + key);
                return null;
            }
            return item.value;
        } catch (e) {
            localStorage.removeItem(PREFIX + key);
            return null;
        }
    },
    remove: (key) => localStorage.removeItem(PREFIX + key),
    clear: () => {
        clearAll();
        // Remove the version cookie so other subdomains detect the invalidation
        Cookies.remove(VERSION_COOKIE, {domain: process.env.REACT_APP_HOST});
        localStorage.removeItem(VERSION_KEY);
    }
};
